// extracted by mini-css-extract-plugin
export default {"container":"unit-pill_container__QiMKZ","value":"unit-pill_value__1YItw","unit":"unit-pill_unit__Suh7O"};